import React from "react";
import {observer} from "mobx-react-lite"

import {RectangleTableLeft} from "./rectangleTableLeft";
import {RectangleTableRight} from "./rectangleTableRight";
import {RectangleTableCenter} from "./rectangleTableCenter";
import {gameStore} from "../../../store/gameStore";

export const RectangleTableTop = observer(({
                                             selectedData,
                                             memoAllChipsTypes,
                                             ovalTableBetState,
                                             handleGetColumnChip,
                                             winNumber
                                           }) => {
  const {isBetsClosed} = gameStore;
  return (
    <div className="main-game-cont-table-top">
      <RectangleTableLeft
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        ovalTableBetState={ovalTableBetState}
        handleGetColumnChip={handleGetColumnChip}
        winNumber={winNumber}
        isBetsClosed={isBetsClosed}
      />
      <RectangleTableCenter
        winNumber={winNumber}
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        ovalTableBetState={ovalTableBetState}
        handleGetColumnChip={handleGetColumnChip}
      />
      <RectangleTableRight
        selectedData={selectedData}
        allChipsTypes={memoAllChipsTypes}
        handleGetColumnChip={handleGetColumnChip}
      />
    </div>
  )
});
